/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GetSegmentsParams = {
thread_id?: string | null;
after_idx?: number | null;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
};
